import { useEffect as e, useState as t } from "react";
import { css as n, styled as r } from "styled-components";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/Transition/Transition.tsx
var a = (e, t) => {
	switch (e) {
		case "fade": return n`
                opacity: ${t ? 1 : 0};
                pointer-events: ${t ? "auto" : "none"};
            `;
		case "slide-up": return n`
                opacity: ${t ? 1 : 0};
                transform: ${t ? "translateY(0)" : "translateY(20px)"};
                pointer-events: ${t ? "auto" : "none"};
            `;
		case "slide-down": return n`
                opacity: ${t ? 1 : 0};
                transform: ${t ? "translateY(0)" : "translateY(-20px)"};
                pointer-events: ${t ? "auto" : "none"};
            `;
		case "expand": return n`
                max-height: ${t ? "1000px" : "0px"};
                overflow: hidden;
            `;
		case "fade-expand": return n`
                opacity: ${t ? 1 : 0};
                max-height: ${t ? "1000px" : "0px"};
                overflow: hidden;
                pointer-events: ${t ? "auto" : "none"};
            `;
		case "slide-fade-expand": return n`
                opacity: ${t ? 1 : 0};
                transform: ${t ? "translateY(0)" : "translateY(20px)"};
                max-height: ${t ? "1000px" : "0px"};
                overflow: hidden;
                pointer-events: ${t ? "auto" : "none"};
            `;
		default: return "";
	}
}, o = r.div`
    transition-property: all;
    transition-duration: ${({ $duration: e }) => e}ms;
    transition-delay: ${({ $delay: e }) => e}ms;
    transition-timing-function: ${({ $easing: e }) => e};

    ${({ $variant: e, $show: t }) => a(e, t)}
`, s = ({ show: n = !0, variant: r = "fade", duration: a = 300, delay: s = 0, easing: c = "ease-in-out", unmountOnExit: l = !1, children: u, ...d }) => {
	let [f, p] = t(n), [m, h] = t(!1);
	return e(() => {
		let e;
		return n ? (p(!0), e = setTimeout(() => {
			h(!0);
		}, 10)) : (h(!1), l && (e = setTimeout(() => {
			p(!1);
		}, a + s))), () => clearTimeout(e);
	}, [
		n,
		l,
		a,
		s
	]), !f && l ? null : /* @__PURE__ */ i(o, {
		$show: m,
		$variant: r,
		$duration: a,
		$delay: s,
		$easing: c,
		...d,
		children: u
	});
};
//#endregion
export { s as Transition };
